import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.url";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/work/english/new-evaluation/src/admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "E:/work/english/new-evaluation/src/admin/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions } from 'vuex';
import { request } from '@/api/service';
import util from '@/libs/util'; // 需求：题库管理-筛选状态保持。列表页筛选条件/页码持久化 key，
// 解决"打开编辑页再返回后条件被重置"问题（不依赖 keep-alive 是否命中）

var FILTER_CACHE_KEY = 'question-bank-list-filter-cache';
export default {
  name: 'question-bank-list',
  data: function data() {
    return {
      loading: false,
      query: {
        keyword: '',
        choiceKeyword: '',
        id: undefined,
        questionTypeId: '',
        skillDimension: '',
        difficulty: '',
        status: '',
        grade: '',
        book: '',
        unit: '',
        module: ''
      },
      tableData: [],
      selectedRows: [],
      batchBinding: false,
      allBinding: false,
      rebuildBinding: false,
      pagination: {
        current: 1,
        size: 20,
        total: 0
      },
      statusCounts: {},
      nodeDialogVisible: false,
      nodeLoading: false,
      currentNodeQuestion: {},
      currentNodes: [],
      // 知识图谱三级选择绑定
      gradeOptions: [{
        value: 'grade3',
        label: '三年级'
      }, {
        value: 'grade4',
        label: '四年级'
      }, {
        value: 'grade5',
        label: '五年级'
      }, {
        value: 'grade6',
        label: '六年级'
      }],
      bookOptions: [{
        value: 'up',
        label: '上册'
      }, {
        value: 'down',
        label: '下册'
      }],
      // 知识模块选项
      moduleOptions: [{
        value: 'vocabulary',
        label: '词汇'
      }, {
        value: 'grammar',
        label: '语法'
      }, {
        value: 'sentence',
        label: '句型'
      }, {
        value: 'phonetics',
        label: '语音'
      }, {
        value: 'function_topic',
        label: '功能话题'
      }, {
        value: 'listening',
        label: '听力'
      }, {
        value: 'reading',
        label: '阅读'
      }, {
        value: 'writing',
        label: '写作'
      }],
      // 单元筛选选项（从后端动态加载）
      unitFilterOptions: [],
      bindForm: {
        grade: '',
        book: '',
        unit: '',
        nodeId: ''
      },
      unitOptions: [],
      nodeOptions: [],
      // 路径详情
      pathDialogVisible: false,
      pathLoading: false,
      pathQuestion: {},
      pathDetails: [],
      // 导入相关
      importing: false,
      importDialog: {
        visible: false
      },
      importResult: null,
      // keep-alive 首次挂载顺序为 mounted -> activated，用该标记让 activated 跳过首次，避免重复请求
      firstRender: true
    };
  },
  mounted: function mounted() {
    // 需求：题库管理-筛选状态保持。组件若被销毁重建，从 sessionStorage 恢复筛选条件与页码
    // restore 返回 true 表示已通过恢复单元选项链路触发过 loadData，不再重复请求
    if (!this.restoreFilterCache()) {
      this.loadData();
    }
  },
  // 配合路由 meta.cache（keep-alive）：从编辑页返回时组件不销毁，筛选条件与页码自然保留，仅需刷新数据
  activated: function activated() {
    if (this.firstRender) {
      // 首次挂载 mounted 已加载，跳过；后续从缓存激活时刷新
      this.firstRender = false;
      return;
    }

    this.loadData();
  },
  computed: {
    uploadAction: function uploadAction() {
      return (process.env.VUE_APP_API || '') + '/api/questions/import';
    },
    uploadHeaders: function uploadHeaders() {
      var token = util.cookies.get('token');
      return token ? {
        token: token
      } : {};
    },
    importSummary: function importSummary() {
      if (!this.importResult) return '';
      var r = this.importResult;
      var s = "\u6210\u529F ".concat(r.successCount, " \u6761");
      if (r.skippedCount) s += "\uFF0C\u8DF3\u8FC7 ".concat(r.skippedCount, " \u6761\uFF08nodeId \u5DF2\u5B58\u5728\uFF09");
      if (r.failedRows && r.failedRows.length) s += "\uFF0C\u5931\u8D25 ".concat(r.failedRows.length, " \u6761");
      return s;
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/page', ['close'])), {}, {
    loadData: function loadData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true; // 需求：题库管理-筛选状态保持。每次加载时持久化当前筛选与分页，供组件重建后恢复

                _this.saveFilterCache();

                _context.prev = 2;
                params = {
                  page: _this.pagination.current - 1,
                  size: _this.pagination.size
                }; // 仅传有值的筛选参数，避免空字符串导致 questionTypeId 整数类型转换失败

                Object.keys(_this.query).forEach(function (k) {
                  var v = _this.query[k];

                  if (v !== '' && v !== null && v !== undefined) {
                    params[k] = v;
                  }
                });
                _context.next = 7;
                return _this.$api.loadQuestionList(params);

              case 7:
                res = _context.sent;
                _this.tableData = res.content || [];
                _this.pagination.total = res.totalElements || 0;

                _this.countStatuses();

                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](2);

                _this.$message.error('加载题目列表失败');

              case 16:
                _context.prev = 16;
                _this.loading = false;
                return _context.finish(16);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 13, 16, 19]]);
      }))();
    },
    countStatuses: function countStatuses() {
      var _this2 = this;

      this.statusCounts = {};
      this.tableData.forEach(function (item) {
        var s = item.status || 'draft';
        _this2.statusCounts[s] = (_this2.statusCounts[s] || 0) + 1;
      });
    },
    handleSelectionChange: function handleSelectionChange(rows) {
      this.selectedRows = rows;
    },
    // 需求：题库管理-筛选状态保持。保存筛选条件与分页到 sessionStorage
    saveFilterCache: function saveFilterCache() {
      try {
        sessionStorage.setItem(FILTER_CACHE_KEY, JSON.stringify({
          query: this.query,
          current: this.pagination.current,
          size: this.pagination.size
        }));
      } catch (e) {
        /* 存储异常不影响主流程 */
      }
    },
    // 需求：题库管理-筛选状态保持。从 sessionStorage 恢复筛选条件与分页（total 由接口返回，不缓存）
    // 返回值：true 表示恢复链路中已触发 loadData（调用方无需再加载）
    restoreFilterCache: function restoreFilterCache() {
      try {
        var raw = sessionStorage.getItem(FILTER_CACHE_KEY);
        if (!raw) return false;
        var cache = JSON.parse(raw);

        if (cache && cache.query) {
          this.query = _objectSpread(_objectSpread({}, this.query), cache.query);
          this.pagination.current = cache.current || 1;
          this.pagination.size = cache.size || this.pagination.size; // 恢复了年级+册别时同步恢复单元下拉选项（内部会触发 loadData），避免筛选标签为空

          if (this.query.grade && this.query.book) {
            this.loadUnitFilterOptions();
            return true;
          }
        }
      } catch (e) {
        /* 解析异常按无缓存处理 */
      }

      return false;
    },
    handleSearch: function handleSearch() {
      this.pagination.current = 1;
      this.loadData();
    },
    // 年级筛选变化：清空单元选项并重新加载
    handleGradeFilterChange: function handleGradeFilterChange() {
      this.query.unit = '';
      this.unitFilterOptions = []; // 如果选了年级和册别，加载单元列表

      if (this.query.grade && this.query.book) {
        this.loadUnitFilterOptions();
      } else {
        this.loadData();
      }
    },
    // 册别筛选变化：清空单元选项并重新加载
    handleBookFilterChange: function handleBookFilterChange() {
      this.query.unit = '';
      this.unitFilterOptions = []; // 如果选了年级和册别，加载单元列表

      if (this.query.grade && this.query.book) {
        this.loadUnitFilterOptions();
      } else {
        this.loadData();
      }
    },
    // 加载单元筛选选项
    loadUnitFilterOptions: function loadUnitFilterOptions() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res, overview, units;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _this3.$api.getKgOverview(_this3.query.grade, _this3.query.book);

              case 3:
                res = _context2.sent;
                overview = res && res.data ? res.data : res;
                units = overview && overview.units ? overview.units : [];
                _this3.unitFilterOptions = units.map(function (u) {
                  return {
                    code: u.code,
                    name: (u.name_en ? u.name_en + ' ' : '') + (u.theme_cn ? u.theme_cn : '')
                  };
                });

                _this3.loadData();

                _context2.next = 14;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](0);
                _this3.unitFilterOptions = [];

                _this3.$message.error('加载单元列表失败');

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 10]]);
      }))();
    },
    // 重置筛选条件
    handleResetFilter: function handleResetFilter() {
      this.query = {
        keyword: '',
        choiceKeyword: '',
        id: undefined,
        questionTypeId: '',
        skillDimension: '',
        difficulty: '',
        status: '',
        grade: '',
        book: '',
        unit: '',
        module: ''
      };
      this.unitFilterOptions = [];
      this.pagination.current = 1;
      this.loadData();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pagination.size = size;
      this.loadData();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.pagination.current = page;
      this.loadData();
    },
    handleCreate: function handleCreate() {
      this.$router.push({
        name: 'question-bank-edit',
        params: {
          id: 'new'
        }
      });
    },
    handleView: function handleView(row) {
      this.$router.push({
        name: 'question-bank-edit',
        params: {
          id: row.id
        },
        query: {
          readonly: '1'
        }
      });
    },
    handleEdit: function handleEdit(row) {
      this.$router.push({
        name: 'question-bank-edit',
        params: {
          id: row.id
        }
      });
    },
    // 跳转到 QC 质检工作台并定位到该题
    handleGoQc: function handleGoQc(row) {
      this.$router.push({
        name: 'question-bank-qc',
        query: {
          id: row.id
        }
      });
    },
    handleDelete: function handleDelete(row) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _this4.$api.deleteQuestion(row.id);

              case 3:
                _this4.$message.success('删除成功');

                _this4.loadData();

                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);

                _this4.$message.error('删除失败');

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 7]]);
      }))();
    },
    handleBindNode: function handleBindNode(row) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.currentNodeQuestion = row;

                _this5.resetBindForm();

                _this5.nodeDialogVisible = true;
                _context4.next = 5;
                return _this5.refreshCurrentNodes();

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 刷新当前题目的绑定知识点（用 detail 接口，含名称与路径）
    refreshCurrentNodes: function refreshCurrentNodes() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.nodeLoading = true;
                _context5.prev = 1;
                _context5.next = 4;
                return _this6.$api.getQuestionNodeDetail(_this6.currentNodeQuestion.id);

              case 4:
                res = _context5.sent;
                _this6.currentNodes = res || [];
                _context5.next = 11;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](1);
                _this6.currentNodes = [];

              case 11:
                _context5.prev = 11;
                _this6.nodeLoading = false;
                return _context5.finish(11);

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[1, 8, 11, 14]]);
      }))();
    },
    resetBindForm: function resetBindForm() {
      this.bindForm = {
        grade: '',
        book: '',
        unit: '',
        nodeId: ''
      };
      this.unitOptions = [];
      this.nodeOptions = [];
    },
    // 年级变化：加载册别（固定），并清空下层
    handleGradeChange: function handleGradeChange() {
      this.bindForm.book = '';
      this.bindForm.unit = '';
      this.bindForm.nodeId = '';
      this.unitOptions = [];
      this.nodeOptions = [];
    },
    // 册别变化：加载单元列表
    handleBookChange: function handleBookChange() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var res, overview, units;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this7.bindForm.unit = '';
                _this7.bindForm.nodeId = '';
                _this7.nodeOptions = [];

                if (!(!_this7.bindForm.grade || !_this7.bindForm.book)) {
                  _context6.next = 5;
                  break;
                }

                return _context6.abrupt("return");

              case 5:
                _context6.prev = 5;
                _context6.next = 8;
                return _this7.$api.getKgOverview(_this7.bindForm.grade, _this7.bindForm.book);

              case 8:
                res = _context6.sent;
                // overview.data.units: [{code, name_en, theme_cn, count}]
                overview = res && res.data ? res.data : res;
                units = overview && overview.units ? overview.units : [];
                _this7.unitOptions = units.map(function (u) {
                  return {
                    code: u.code,
                    name: (u.name_en ? u.name_en + ' ' : '') + (u.theme_cn ? u.theme_cn : '')
                  };
                });
                _context6.next = 18;
                break;

              case 14:
                _context6.prev = 14;
                _context6.t0 = _context6["catch"](5);
                _this7.unitOptions = [];

                _this7.$message.error('加载单元列表失败');

              case 18:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[5, 14]]);
      }))();
    },
    // 单元变化：加载知识点列表
    handleUnitChange: function handleUnitChange() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var res, unitData, nodes;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this8.bindForm.nodeId = '';
                _this8.nodeOptions = [];

                if (!(!_this8.bindForm.grade || !_this8.bindForm.book || !_this8.bindForm.unit)) {
                  _context7.next = 4;
                  break;
                }

                return _context7.abrupt("return");

              case 4:
                _context7.prev = 4;
                _context7.next = 7;
                return _this8.$api.getKgUnit(_this8.bindForm.grade, _this8.bindForm.book, _this8.bindForm.unit);

              case 7:
                res = _context7.sent;
                // unit.data.nodes: [{id(nodeId), name, type, ...}]
                unitData = res && res.data ? res.data : res;
                nodes = unitData && unitData.nodes ? unitData.nodes : [];
                _this8.nodeOptions = nodes;
                _context7.next = 17;
                break;

              case 13:
                _context7.prev = 13;
                _context7.t0 = _context7["catch"](4);
                _this8.nodeOptions = [];

                _this8.$message.error('加载知识点失败');

              case 17:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[4, 13]]);
      }))();
    },
    handleBindSelected: function handleBindSelected() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (_this9.bindForm.nodeId) {
                  _context8.next = 2;
                  break;
                }

                return _context8.abrupt("return");

              case 2:
                _context8.prev = 2;
                _context8.next = 5;
                return _this9.$api.bindQuestionNode(_this9.currentNodeQuestion.id, {
                  nodeId: _this9.bindForm.nodeId,
                  bindType: 'primary',
                  relevanceScore: 1.0
                });

              case 5:
                _this9.$message.success('绑定成功');

                _this9.bindForm.nodeId = '';
                _context8.next = 9;
                return _this9.refreshCurrentNodes();

              case 9:
                _this9.loadData();

                _context8.next = 15;
                break;

              case 12:
                _context8.prev = 12;
                _context8.t0 = _context8["catch"](2);

                _this9.$message.error('绑定失败');

              case 15:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[2, 12]]);
      }))();
    },
    handleAutoBind: function handleAutoBind() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return _this10.$api.autoBindNodes(_this10.currentNodeQuestion.id);

              case 3:
                _this10.$message.success('自动匹配绑定完成');

                _context9.next = 6;
                return _this10.refreshCurrentNodes();

              case 6:
                _this10.loadData();

                _context9.next = 12;
                break;

              case 9:
                _context9.prev = 9;
                _context9.t0 = _context9["catch"](0);

                _this10.$message.error('自动绑定失败');

              case 12:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[0, 9]]);
      }))();
    },
    // 清空重绑：删除全部存量绑定后按当前规则对所有题目统一重绑（纠偏历史错绑）
    handleRebuild: function handleRebuild() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var res, stat;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!_this11.rebuildBinding) {
                  _context10.next = 2;
                  break;
                }

                return _context10.abrupt("return");

              case 2:
                _context10.prev = 2;
                _context10.next = 5;
                return _this11.$confirm('将删除全部存量知识点绑定，并按当前规则对全部题目重新自动绑定。此操作不可撤销，是否继续？', '清空重绑', {
                  type: 'warning',
                  confirmButtonText: '确认清空重绑',
                  cancelButtonText: '取消',
                  confirmButtonClass: 'el-button--danger'
                });

              case 5:
                _context10.next = 10;
                break;

              case 7:
                _context10.prev = 7;
                _context10.t0 = _context10["catch"](2);
                return _context10.abrupt("return");

              case 10:
                _this11.rebuildBinding = true;
                _context10.prev = 11;
                _context10.next = 14;
                return _this11.$api.autoBindRebuild();

              case 14:
                res = _context10.sent;
                stat = res && res.data ? res.data : res || {};

                _this11.$message.success("\u6E05\u7A7A\u91CD\u7ED1\u5B8C\u6210\uFF1A\u5904\u7406 ".concat(stat.processed || 0, " \u9898\uFF0C\u7ED1\u5B9A ").concat(stat.bound || 0, " \u9898\uFF0C\u672A\u5339\u914D ").concat(stat.noMatch || 0, " \u9898"));

                _this11.loadData();

                _context10.next = 23;
                break;

              case 20:
                _context10.prev = 20;
                _context10.t1 = _context10["catch"](11);

                _this11.$message.error('清空重绑失败');

              case 23:
                _context10.prev = 23;
                _this11.rebuildBinding = false;
                return _context10.finish(23);

              case 26:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, null, [[2, 7], [11, 20, 23, 26]]);
      }))();
    },
    // 一键全量自动绑定（为所有未绑定知识点的题目自动匹配绑定）
    handleAutoBindAll: function handleAutoBindAll() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var res, stat;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (!_this12.allBinding) {
                  _context11.next = 2;
                  break;
                }

                return _context11.abrupt("return");

              case 2:
                _context11.prev = 2;
                _context11.next = 5;
                return _this12.$confirm('将为所有当前未绑定知识点的题目自动匹配绑定知识点（已绑定的题目跳过），是否继续？', '一键全量绑定', {
                  type: 'warning',
                  confirmButtonText: '开始绑定',
                  cancelButtonText: '取消'
                });

              case 5:
                _context11.next = 10;
                break;

              case 7:
                _context11.prev = 7;
                _context11.t0 = _context11["catch"](2);
                return _context11.abrupt("return");

              case 10:
                _this12.allBinding = true;
                _context11.prev = 11;
                _context11.next = 14;
                return _this12.$api.autoBindAllNodes();

              case 14:
                res = _context11.sent;
                stat = res && res.data ? res.data : res || {};

                _this12.$message.success("\u5168\u91CF\u7ED1\u5B9A\u5B8C\u6210\uFF1A\u5904\u7406 ".concat(stat.processed || 0, " \u9898\uFF0C\u65B0\u7ED1\u5B9A ").concat(stat.bound || 0, " \u9898\uFF0C\u8DF3\u8FC7 ").concat(stat.skipped || 0, " \u9898"));

                _this12.loadData();

                _context11.next = 23;
                break;

              case 20:
                _context11.prev = 20;
                _context11.t1 = _context11["catch"](11);

                _this12.$message.error('全量绑定失败');

              case 23:
                _context11.prev = 23;
                _this12.allBinding = false;
                return _context11.finish(23);

              case 26:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, null, [[2, 7], [11, 20, 23, 26]]);
      }))();
    },
    // 批量自动绑定选中题目（词汇层 + 句法层）
    handleBatchAutoBind: function handleBatchAutoBind() {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var ids, res, boundCount;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!(!_this13.selectedRows.length || _this13.batchBinding)) {
                  _context12.next = 2;
                  break;
                }

                return _context12.abrupt("return");

              case 2:
                ids = _this13.selectedRows.map(function (r) {
                  return r.id;
                });
                _this13.batchBinding = true;
                _context12.prev = 4;
                _context12.next = 7;
                return _this13.$api.autoBindNodesBatch(ids);

              case 7:
                res = _context12.sent;
                boundCount = res && res.length ? res.length : 0;

                _this13.$message.success("\u6279\u91CF\u81EA\u52A8\u7ED1\u5B9A\u5B8C\u6210\uFF0C".concat(boundCount, " \u9053\u9898\u76EE\u5DF2\u7ED1\u5B9A\u77E5\u8BC6\u70B9"));

                _this13.loadData();

                _context12.next = 16;
                break;

              case 13:
                _context12.prev = 13;
                _context12.t0 = _context12["catch"](4);

                _this13.$message.error('批量自动绑定失败');

              case 16:
                _context12.prev = 16;
                _this13.batchBinding = false;
                return _context12.finish(16);

              case 19:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, null, [[4, 13, 16, 19]]);
      }))();
    },
    handleUnbindNode: function handleUnbindNode(row) {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                _context13.next = 3;
                return _this14.$api.unbindQuestionNode(_this14.currentNodeQuestion.id, row.nodeId);

              case 3:
                _this14.$message.success('解绑成功');

                _context13.next = 6;
                return _this14.refreshCurrentNodes();

              case 6:
                _this14.loadData();

                _context13.next = 12;
                break;

              case 9:
                _context13.prev = 9;
                _context13.t0 = _context13["catch"](0);

                _this14.$message.error('解绑失败');

              case 12:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, null, [[0, 9]]);
      }))();
    },
    // 列表中点击知识点标签 -> 查看该题全部绑定路径
    handleViewNodePath: function handleViewNodePath(row) {
      this.handleViewPath(row);
    },
    // 查看题目全部绑定知识点路径
    handleViewPath: function handleViewPath(row) {
      var _this15 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var res;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _this15.currentNodeQuestion = row;
                _this15.pathQuestion = row;
                _this15.pathDialogVisible = true;
                _this15.pathLoading = true;
                _context14.prev = 4;
                _context14.next = 7;
                return _this15.$api.getQuestionNodeDetail(row.id);

              case 7:
                res = _context14.sent;
                _this15.pathDetails = res || [];
                _context14.next = 14;
                break;

              case 11:
                _context14.prev = 11;
                _context14.t0 = _context14["catch"](4);
                _this15.pathDetails = [];

              case 14:
                _context14.prev = 14;
                _this15.pathLoading = false;
                return _context14.finish(14);

              case 17:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, null, [[4, 11, 14, 17]]);
      }))();
    },
    // 绑定弹窗中查看单个知识点路径
    handleViewSinglePath: function handleViewSinglePath(row) {
      var _this16 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _this16.pathQuestion = _this16.currentNodeQuestion;
                _this16.pathDetails = [row];
                _this16.pathDialogVisible = true;

              case 3:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }))();
    },
    // 需求ID: REQ-20261029-VIEWING — 技能维度 5 值标签/配色；viewing 复用既有 info 色，不新增学科语义
    dimensionTagType: function dimensionTagType(dim) {
      var map = {
        listening: '',
        reading: 'success',
        viewing: 'info',
        writing: 'warning',
        comprehensive: 'primary'
      };
      return map[dim] || 'info';
    },
    dimensionLabel: function dimensionLabel(dim) {
      var map = {
        listening: '听力',
        reading: '阅读',
        viewing: '看',
        writing: '写作',
        comprehensive: '综合'
      };
      return map[dim] || dim || 'N/A';
    },
    statusTagType: function statusTagType(status) {
      // 题目状态仅两态：草稿 / 已发布
      var map = {
        draft: 'info',
        published: 'success'
      };
      return map[status] || 'info';
    },
    statusLabel: function statusLabel(status) {
      // 题目状态仅两态：草稿 / 已发布
      var map = {
        draft: '草稿',
        published: '已发布'
      };
      return map[status] || status;
    },
    questionTypeIdLabel: function questionTypeIdLabel(id) {
      var map = {
        1: '单选',
        2: '连线',
        3: '排序',
        4: '简答',
        5: '长文本',
        6: '多选'
      };
      return map[id];
    },
    // 布卢姆统一为中文6级，兼容旧英文枚举
    bloomLabel: function bloomLabel(level) {
      var map = {
        记忆: '记忆',
        理解: '理解',
        应用: '应用',
        分析: '分析',
        评价: '评价',
        创造: '创造',
        remember: '记忆',
        understand: '理解',
        apply: '应用',
        analyze: '分析',
        evaluate: '评价',
        create: '创造'
      };
      return map[level] || level || 'N/A';
    },
    // 难度从 difficultyJson 解析三星制档位
    difficultyLabel: function difficultyLabel(json) {
      if (!json) return 'N/A';

      try {
        var d = JSON.parse(json);
        if (d.level) return d.level;
        if (d.stars != null) return ['★', '★★', '★★★'][Number(d.stars) - 1] || 'N/A';
        if (d.finalDifficulty != null) return ['★', '★★', '★★★'][Number(d.finalDifficulty) - 1] || 'N/A';
        return 'N/A';
      } catch (e) {
        return 'N/A';
      }
    },
    nodeTypeLabel: function nodeTypeLabel(type) {
      var map = {
        vocabulary: '词汇',
        grammar: '语法',
        sentence: '句型',
        phonetics: '语音',
        function: '功能',
        topic: '话题',
        review: '综合测评'
      };
      return map[type] || type || '未知';
    },
    // ---- 导入相关 ----
    handleDownloadTemplate: function handleDownloadTemplate() {
      var _this17 = this;

      this.$message.info('正在下载导入模板...');
      request({
        url: '/api/questions/import/template',
        method: 'GET',
        responseType: 'blob'
      }).then(function (blob) {
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = 'question-import-template.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }).catch(function (err) {
        _this17.$message.error('模板下载失败：' + (err && err.message ? err.message : '网络错误'));
      });
    },
    handleOpenImport: function handleOpenImport() {
      this.importDialog.visible = true;
      this.importResult = null;
    },
    handleBeforeUpload: function handleBeforeUpload(file) {
      var maxSize = 10 * 1024 * 1024; // 10MB

      if (file.size > maxSize) {
        this.$message.error('文件不能超过 10MB');
        return false;
      }

      var ext = file.name.split('.').pop().toLowerCase();

      if (!['xlsx', 'xls'].includes(ext)) {
        this.$message.error('只能上传 Excel 文件');
        return false;
      }

      return true;
    },
    submitImport: function submitImport() {
      var _this18 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                if (!(!_this18.$refs.uploadRef || !_this18.$refs.uploadRef.uploadFiles.length)) {
                  _context16.next = 3;
                  break;
                }

                _this18.$message.warning('请先选择文件');

                return _context16.abrupt("return");

              case 3:
                _this18.importing = true;
                _this18.importResult = null;
                _context16.prev = 5;
                _context16.next = 8;
                return _this18.$refs.uploadRef.submit();

              case 8:
                _context16.prev = 8;
                _this18.importing = false;
                return _context16.finish(8);

              case 11:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, null, [[5,, 8, 11]]);
      }))();
    },
    handleImportSuccess: function handleImportSuccess(response) {
      // el-upload 的 on-success 拿到的是原始 response，需要解包 Result.ok 结构
      var data = response && response.data ? response.data : response;
      this.importResult = data;
      var r = data || {};

      if (r.successCount > 0) {
        this.$message.success("\u6210\u529F\u5BFC\u5165 ".concat(r.successCount, " \u6761"));
        this.handleSearch(); // 刷新列表
      }
    },
    handleImportError: function handleImportError(err) {
      this.$message.error('导入失败：' + (err && err.message ? err.message : '网络错误'));
    }
  })
};